import { reaction } from 'mobx';
import React from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import debug from '../debug';
import ConsoleStore from '../stores/ConsoleStore';
import InputStore from '../stores/InputStore';
import reLooksLikeUrl from '../urlValidator';
import SearchField from './SearchField/SearchField';

class CategoryLookup extends React.Component {
    static propTypes = {
        inputStore: InputStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
        searchResultStore: MobxPropTypes.observableArray.isRequired,
    };

    disposeReaction = null;

    lookUpTm = null;

    componentDidMount() {
        const { inputStore } = this.props;
        this.disposeReaction = reaction(() => inputStore.value, (newValue) => {
            this.props.searchResultStore.replace([]);

            clearTimeout(this.lookUpTm);
            this.lookUpTm = null;

            const value = newValue.trim().toLowerCase();
            if (reLooksLikeUrl.test(value)) {
                const lookUpTm = setTimeout(() =>
                    this.props.console.apiCategories({ value })
                        .then((result) => {
                            if (lookUpTm === this.lookUpTm) {
                                this.props.searchResultStore.replace(result.map((c) => c.id));
                            }
                        })
                        .catch(debug.warn)
                , 500);
                this.lookUpTm = lookUpTm;
            }
        });
    }

    componentWillUnmount() {
        if (this.disposeReaction) {
            this.disposeReaction();
        }
    }

    render() {
        return <SearchField {...this.props} />;
    }
}

export default (inject('console')(observer(CategoryLookup)));
